import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/Rx'; // importing RxJs operators like map
import { TopTenModel } from '../model/top_ten.model';
import { DashboardHeaderStatsModel } from '../model/dashboard_header_stats.model';
import { HospitalActivityModel } from '../model/hospital_activity.model';
import { ProcedureMonthlyModel } from '../model/procedure_monthly.model';
import { ItemQuantityModel } from '../model/item_quantity.model';

import { API_URLS } from '../utils/api_url.util';
import { API_UTILS } from '../utils/api_utils.util';
import { FacultyStudentMedicalProcedureModel } from '../model/faculty_student_medical_procedure_summary.model';
import { catchError } from 'rxjs/operators';
import { TraineeMedicalProcedureCaseModel } from '../model/trainee_medical_procedure_case.model';
import { UserActivityModel } from '../model/user_activity.model';

/*
  Generated class for the UserFaculties provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class StatsService {
	topTenTrainees: TopTenModel[];
	topTenTrainers: TopTenModel[];
	dashHeaderStats: DashboardHeaderStatsModel;

	constructor(private http: HttpClient) {
		this.topTenTrainees = null;
		this.topTenTrainers = null;
		this.dashHeaderStats = null;
	}

	/*

  getItemsByCategory(categoryId:number)
  {
     if(this.items)
     {
         return Promise.resolve(this.items)
     }

      // don't have the data yet
    return new Promise(resolve => {
      // We're using Angular Http provider to request the data,
      // then on the response it'll map the JSON data to a parsed JS object.
      // Next we process the data and resolve the promise with the new data.
      this.http.get(API_URLS.API_GET_HERITAGE_ITEM_BY_CATEGORY+'/admin'+'/${categoryId}')
        .map(res => <Array<HeritageItemModel>>res.json())
        .subscribe(data => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          this.items= data;
          resolve(this.items);
        });
    });


  }

  */

	getTopTenTrainers(): Observable<Array<TopTenModel>> {
		let items$ = this.http
			.get<Array<TopTenModel>>(API_URLS.API_GET_STATS_TOP_TEN_TRAINERS)
			.pipe(catchError(handleError));
		return items$;
	}

	getTopTenTrainees(): Observable<Array<TopTenModel>> {
		let items$ = this.http
			.get<Array<TopTenModel>>(API_URLS.API_GET_STATS_TOP_TEN_TRAINEES)
			.pipe(catchError(handleError));
		return items$;
	}

	getProcedureMonthlyTrendByTrainee(userId: string): Observable<ProcedureMonthlyModel[]> {
		let items$ = this.http
			.get<ProcedureMonthlyModel[]>(API_URLS.API_GET_STATS_PROCEDURE_MONTHLY_BY_TRAINEE + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getProcedureMonthlyTrendByFaculty(facultyId: string): Observable<ProcedureMonthlyModel[]> {
		let items$ = this.http
			.get<ProcedureMonthlyModel[]>(API_URLS.API_GET_STATS_PROCEDURE_MONTHLY_BY_FACULTY + `/${facultyId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getDashBoardHeaderStats(facultyId: string): Observable<DashboardHeaderStatsModel> {
		let items$ = this.http
			.get<DashboardHeaderStatsModel>(API_URLS.API_GET_STATS_DASHBOARD_HEADER_STATS + `/${facultyId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyRecentMedicalProcedureCases(facultyId: string): Observable<Array<TraineeMedicalProcedureCaseModel>> {
		let items$ = this.http
			.get<Array<TraineeMedicalProcedureCaseModel>>(
				API_URLS.API_GET_STATS_RECENT_MEDICAL_PROCEDURE_CASES + `/${facultyId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyStudentsProcedureSummary(
		facultyId: string,
		startDate: string,
		endDate: string
	): Observable<Array<FacultyStudentMedicalProcedureModel>> {
		let items$ = this.http
			.get<Array<FacultyStudentMedicalProcedureModel>>(
				API_URLS.API_GET_FACULTY_STUDENTS_PROCEDURE_SUMMARY + `/${facultyId}` + `/${startDate}` + `/${endDate}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getHospitalActivities(): Observable<HospitalActivityModel[]> {
		let items$ = this.http
			.get<HospitalActivityModel[]>(API_URLS.API_GET_STATS_HOSPITAL_ACTIVITIES)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeCPDSummaryReport(userId: string): Observable<ItemQuantityModel[]> {
		let items$ = this.http
			.get<ItemQuantityModel[]>(API_URLS.API_REPORT_GET_TRAINEE_CPD_SUMMARY + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeProceduresSummaryReport(userId: string): Observable<ItemQuantityModel[]> {
		let items$ = this.http
			.get<ItemQuantityModel[]>(API_URLS.API_REPORT_GET_TRAINEE_PROCEDURES_SUMMARY_BY_TRAINEE_ROLE + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeActivities(userId: string): Observable<UserActivityModel[]> {
		let items$ = this.http
			.get<UserActivityModel[]>(API_URLS.API_GET_STUDENT_ACTIVITIES + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeActivitiesReports(): Observable<Array<UserActivityModel>> {
		let items$ = this.http
			.get<Array<UserActivityModel>>(API_URLS.API_GET_STUDENT_ACTIVITIES_REPORT)
			.pipe(catchError(handleError));
		return items$;
	}

	getSupervisorActivities(userId: string): Observable<UserActivityModel[]> {
		let items$ = this.http
			.get<UserActivityModel[]>(API_URLS.API_GET_SUPERVISIOR_ACTIVITIES + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}
}

// this could also be a private method of the component class
function handleError(error: HttpErrorResponse) {
	// log error
	// could be something more sofisticated
	console.error(error);

	return observableThrowError(error.error);
}
